import React from 'react'
import './index.css'

export default function PageHeader({
  title,
  subTitle,
  links,
  text,
  subscribeButton,
}) {
  return (
    <>
      <div className="u-posRelative u-flex u-sm-flexCol">
        <div className="u-flexAuto u-bgColorBrandLight InvestmentProducts-sm-fixedHeader"></div>
        {links && (
          <div
            className={
              'u-flexAuto' +
              (links ? ' HeaderLinks-container' : ' u-bgColorBrandLight')
            }
          ></div>
        )}
        <div className="AbsoluteHeader-container u-bgColorBrandLight">
          <div className="u-sizeConstrained u-sm-paddingBottom2gu u-sm-paddingBottom0">
            <div className="u-flex u-sm-flexCol AbsoluteHeader-container">
              <div className="u-flex u-flexAlignItemsCenter u-md-flexAuto u-lg-flexAuto u-bgColorBrandLight u-sm-bgNone u-textReversed u-textBold InvestmentProducts-sm-fixedHeader">
                <h1 className="u-textColorWhite u-sm-paddingVert3gu u-paddingVert4gu">
                  {title}
                </h1>
              </div>
              {(links || subscribeButton) && (
                <div className="u-flex u-flexCol u-flexJustifyCenter u-paddingLeft5gu u-sm-paddingLeft0 HeaderLinks-container u-sm-bgNone u-sm-paddingVert0 u-paddingVert3gu">
                  {links &&
                    links.map((link) => {
                      return (
                        <div
                          key={link.title}
                          className="u-flex u-flexAlignItemsCenter u-paddingVert2gu"
                        >
                          <span className="Icon--material u-textReversed u-marginRight1gu u-textSizeMsrp1 u-posRelative">
                            {link.icon}
                          </span>
                          <span className="u-textReversed HeaderLinks-link">
                            <a
                              className="u-textColorWhite"
                              href={link.url}
                              data-analytics={link.analytics}
                            >
                              {link.title}
                            </a>
                          </span>
                        </div>
                      )
                    })}
                  {subscribeButton &&
                    subscribeButton.map((button) => {
                      return (
                        <div
                          key={button.dataCategory}
                          className="u-flex u-flexAlignItemsCenter u-sm-paddingTop2gu u-paddingTop0"
                        >
                          <category-subscription-button
                            data-category={button.dataCategory}
                            data-button-not-clicked-text={button.unclickedText}
                            data-button-clicked-text={button.clickedText}
                            data-product-subscribe={button.productSubscribe}
                          />
                        </div>
                      )
                    })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {subTitle && (
        <div className="u-bgColorLight">
          <div className="u-sizeConstrained">
            <div className="u-sizeFill u-flex u-flexAlignItemsCenter u-paddingTop2gu u-paddingBottom2gu">
              <span className="Icon--material u-textColorBrand">info</span>
              <div
                className="u-marginLeft2gu"
                dangerouslySetInnerHTML={{ __html: subTitle }}
              ></div>
            </div>
          </div>
        </div>
      )}
      {text && (
        <div className="u-sizeConstrained u-marginTop10gu u-marginBottom6gu">
          <div className="u-md-size8of12 u-lg-size8of12">
            <p>{text}</p>
          </div>
        </div>
      )}
    </>
  )
}
